import {PaginationQueryFunc} from "../models/pagination-query-func";
import {PaginatedResultsLoader} from "../models/paginated-results-loader";

export class PaginatedResultsLoaderFactory {
    constructor() {}
    
    public getResultsLoader<T>(queryFunction:PaginationQueryFunc) : PaginatedResultsLoader<T> {
        let loader = new PaginatedResultsLoader<T>(queryFunction);
        return loader;
    } 
}


// WEBPACK FOOTER //
// ./src/app/shared/services/pagination-results-loader-factory.service.ts